import { store } from './store';
import authActions from './auth/actions';

export default () => new Promise(() => {
  store.dispatch(authActions.checkAuthorization());
});
